export default __webpack_public_path__ + "static/listplay-b36977616f655a8ac79be134f6148b75.png";